import {
  NewEducationLinkShape,
  NewInterviewShape,
} from "../interfaces/classTypes";
import { InterviewSet } from "./interview_set_class";
import { NewEducationLink } from "./new_education_link_class";

let allIncludedNewInterviews: NewInterviewShape[] = [];
export class NewInterview {
  public id: number;
  // public interviewSetId: number;
  public name: string;
  public stepLinks: NewEducationLinkShape[];
  public setId: number;
  constructor(data: NewInterviewShape, setId?: number) {
    this.id = data.id;
    this.setId = setId;
    this.name = data.name;
    this.stepLinks = data.stepLinks.map(
      (link) => new NewEducationLink(link, this)
    );
    this.save();
  }
  save() {
    allIncludedNewInterviews.push(this);
  }

  static allIncludedNewInterviews() {
    return allIncludedNewInterviews;
  }

  static find_by_id(id) {
    return allIncludedNewInterviews.find((i) => i.id == parseInt(id));
  }
}
